import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { Select } from 'src/components/Select';
import { SearchInput } from 'src/components/SearchInput';
import { StyledSearchBar } from './styled';

import { useDispatch } from 'src/store/useDispatch';

interface ISearch {
  title?: string;
  dropDownItems?: string[];
  entity: string;
  updateEntityField: any;
  updateEntitySearch: any;
  /** Compact header layout: no labels, Search… placeholder, fixed control widths. */
  toolbar?: boolean;
  /**
   * Predefined values per search field, keyed by the dropdown label. A field
   * listed here is matched exactly by the API, so it gets a picker instead of a
   * free-text box — typing "act" for a status only ever returns nothing.
   */
  valueOptions?: Record<string, { value: string; label: string }[]>;
}

const Search: FC<ISearch> = ({
  dropDownItems,
  entity,
  updateEntityField,
  updateEntitySearch,
  toolbar = false,
  valueOptions,
}) => {
  const data: any = useSelector((data) => data);

  const dispatch = useDispatch();

  const search = data[entity]?.data?.search || '';
  const field = data[entity]?.data?.field || '';

  const fieldOptions = valueOptions?.[field];

  return (
    <StyledSearchBar $toolbar={toolbar}>
      {fieldOptions ? (
        <Select
          label={toolbar ? undefined : `Search by ${field}`}
          compact={toolbar}
          options={[{ value: '', label: `All ${field.toLowerCase()}` }, ...fieldOptions]}
          value={search}
          onChange={(e) => {
            dispatch(updateEntitySearch({ search: e.currentTarget.value }));
          }}
        />
      ) : (
        <SearchInput
          label={toolbar ? undefined : `Search by ${field}`}
          placeholder={toolbar ? 'Search...' : undefined}
          inline={toolbar}
          showIcon={toolbar}
          value={search}
          onChange={(nextSearch) => {
            dispatch(
              updateEntitySearch({
                search: nextSearch,
              }),
            );
          }}
        />
      )}
      <Select
        label={toolbar ? undefined : 'Select Field'}
        options={dropDownItems ? dropDownItems.map((i) => ({ value: i, label: i })) : []}
        value={field}
        onChange={(e) => {
          const nextField = e.currentTarget.value;
          dispatch(updateEntitySearch({ search: '' }));
          dispatch(updateEntityField({ field: nextField }));
        }}
      />
    </StyledSearchBar>
  );
};

export default Search;
